const onUnitsPageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('.UnitContractHistoryTable')
    if (pageContent) {
      clearInterval(waitForPageLoad)
      unitBasicInfo()
    }
  }, 100)
}
